import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import {
  Container,
  ContainerContent,
  ContainerHeader,
  DeploymentContextProvider,
  DeploymentPageContent,
  DeploymentPageHeader,
} from '@/component';
import { useUnleash } from '@/package';
import { useMainLayout } from '@/provider';

const DeploymentPage = () => {
  const { setTitle } = useMainLayout();
  const { getVariant } = useUnleash();
  const navigate = useNavigate();
  const variant = getVariant('vuex.demo.modelBuilder');
  const isFeatureEnabled = variant?.feature_enabled;

  useEffect(() => {
    setTitle('Deployment');
  }, [setTitle]);

  useEffect(() => {
    if (isFeatureEnabled) return;

    navigate('/', { replace: true });
  }, [isFeatureEnabled]);

  return (
    <DeploymentContextProvider>
      <Container>
        <ContainerHeader>
          <DeploymentPageHeader />
        </ContainerHeader>
        <ContainerContent>
          <DeploymentPageContent />
        </ContainerContent>
      </Container>
    </DeploymentContextProvider>
  );
};

export default DeploymentPage;
